(function () {
  'use strict';

  // Only run on product pages
  if (!document.querySelector('.product-info')) return;
  // Only run on mobile viewports
  if (window.matchMedia('(min-width: 768px)').matches) return;

  /* -----------------------------------------------------------------------
     "Read more" toggle for the product description
  ----------------------------------------------------------------------- */
  document.querySelectorAll('.product-description.rte').forEach(function (desc) {
    // Only collapse descriptions taller than ~110px
    if (desc.scrollHeight <= 110) return;

    desc.classList.add('is-collapsed');

    var btn = document.createElement('button');
    btn.className = 'product-description__read-more';
    btn.setAttribute('type', 'button');
    btn.textContent = 'Read more';

    btn.addEventListener('click', function () {
      var isCollapsed = desc.classList.toggle('is-collapsed');
      btn.textContent = isCollapsed ? 'Read more' : 'Read less';
    });

    // Insert button immediately after the description div
    desc.parentNode.insertBefore(btn, desc.nextSibling);
  });

  /* -----------------------------------------------------------------------
     Inject the current price into the sticky ATC bar
     The bar shows: [price on left]  [button on right]
  ----------------------------------------------------------------------- */
  var stickyAtc = document.querySelector('sticky-atc');
  if (!stickyAtc) return;

  var details = stickyAtc.querySelector('.sticky-atc__details');
  if (!details) return;

  var priceEl = document.createElement('div');
  priceEl.className = 'sticky-atc__price';
  details.appendChild(priceEl);

  function syncPrice() {
    // .price__current .js-value holds the formatted sale/current price
    var valueEl = document.querySelector('.price-container .price__current .js-value');
    if (valueEl) {
      priceEl.textContent = valueEl.textContent.trim();
    }
  }

  // Initial sync — wait one tick so the theme has hydrated the price
  setTimeout(syncPrice, 0);

  // Re-sync whenever the user picks a different variant
  document.addEventListener('variant:change', function () {
    setTimeout(syncPrice, 100);
  });
})();
